import gql from 'graphql-tag';
export class ChatQueries {
  static commentsQuery = gql`
    query Comments($documentId: String!) {
      comments(documentId: $documentId) {
        id
        recipientId
        userId
        commentText
        createdAt
      }
    }
  `;
}
